import { useRecoilValue } from "recoil";
import { Navigate, Outlet } from "react-router-dom";
import { featuresState } from "../../Recoil/RecoilState";

// Route guard for a feature a superadmin can close (see featureKeysArr). Renders
// while features are still loading; the API enforces access either way.
const RequireFeature = ({ feature }) => {
  const features = useRecoilValue(featuresState);
  if (features !== null && !features.includes(feature)) return <Navigate to="/" />;
  return <Outlet />;
};

export default RequireFeature;
